import { useNavigate, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import EditGroup from 'modules/posts/components/Groups/Edit'

const EditGroupPage = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  return (
    <EditGroup onClose={() => navigate(navigation.dashboard.fullPath())} groupId={Number(id)} />
  )
}

export default EditGroupPage
